import { Block, Inline } from '@contentful/rich-text-types';
import ContentfulNode from '..';

export const EmbeddedEntryInline = (node: Block | Inline): JSX.Element => {
  return <ContentfulNode {...node.data.target} />;
};
